/** AbortSignal.timeout() with fallback for older browsers (Chrome <103, Firefox <100, Safari <16.4).
 * The fallback creates the same DOMException so isTimeoutError() still works. */
export function createTimeoutSignal(timeoutMs: number): AbortSignal {
  if (typeof AbortSignal.timeout === 'function') {
    return AbortSignal.timeout(timeoutMs);
  }
  const controller = new AbortController();
  setTimeout(() => controller.abort(new DOMException('Signal timed out', 'TimeoutError')), timeoutMs);
  return controller.signal;
}

export function isTimeoutError(error: unknown): boolean {
  return error instanceof DOMException && error.name === 'TimeoutError';
}
